import { render } from "./B2bPageGenralsEmit.vue?vue&type=template&id=3090b442&scoped=true&lang=pug"
import script from "./B2bPageGenralsEmit.vue?vue&type=script&lang=js"
export * from "./B2bPageGenralsEmit.vue?vue&type=script&lang=js"

import "./B2bPageGenralsEmit.vue?vue&type=style&index=0&id=3090b442&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3090b442"]])

export default __exports__